import React from "react"
import PropTypes from "prop-types"
import _ from "lodash"
import { useParams, useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
// Material Ui
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
// ## //
import auth from "../../api/authSlice"
import ChangePasswordForm from "./ChangePasswordForm"
import { actions as notifier } from "../../component/notifier"
import { checkUserType } from "../../component/userUtils"
import { STAFF } from "../../commons/userTypes"

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4)
  }
}))

const proptypes = {
  needsToken: PropTypes.bool
}

const defaultprops = {
  needsToken: false
}

const messages = {
  nomatch: {
    defaultMessage: "Old password is invalid",
    id: "action.changepassword.invalid_old_password"
  },
  samepassword: {
    defaultMessage: "The old password is identical to the new password.",
    id: "action.changepassword.same_password"
  },
  success: {
    defaultMessage: "Password changed sucessfully Sucessfully",
    id: "action.changepassword.message"
  },
  invalidToken: {
    defaultMessage: "Invalid token",
    id: "action.changepassword.invalid_token_error"
  },
  unknown: {
    defaultMessage: "Unknown error",
    id: "action.changepassword.unknown_error"
  }
}

function ChangePasswordPage({ needsToken }) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const history = useHistory()
  const { id, token } = useParams()
  const { actions } = auth

  const user = useSelector((state) => state.auth.user)
  const isAdmin = user && checkUserType(user, STAFF)

  /**
   *   ChangePasswordPage is used for two routes : /reset-password and /change-password
   *   reset-password : needsToken = true => old password is not needed
   *   change-password : isAdmin = true => old password is not needed
   *   other cases : need old password
   */
  const noNeedOldPassword = needsToken || isAdmin

  const handleSave = (values) => {
    const task =
      needsToken && token
        ? actions.resetPassword({ token, password: values.password })
        : actions.changePassword(_.assign({ _id: id }, values))

    return dispatch(task).then(({ data }) => {
      if (!data.changed) {
        dispatch(notifier.enqueueError(messages[data.error || "unknown"]))
        return
      }

      dispatch(notifier.enqueueSuccess(messages.success))
      history.push("/login")
    })
  }

  const handleCancel = (event) => {
    event.preventDefault()
    if (history.length === 1) {
      // it means it came from another app (like an email link)
      history.push("/login")
    } else {
      history.goBack()
    }
  }

  const handleNoToken = () => {
    history.push("/login")
    return null
  }

  if (needsToken && !token) {
    return handleNoToken()
  }
  return (
    <Box className={classes.root}>
      <ChangePasswordForm
        handleCancel={handleCancel}
        handleSave={handleSave}
        mustProvideOldPassword={!noNeedOldPassword}
      />
    </Box>
  )
}

ChangePasswordPage.propTypes = proptypes
ChangePasswordPage.defaultProps = defaultprops

export default ChangePasswordPage
